import DefaultLayout from "@/layouts/DefaultLayout";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import InfiniteScroll from "react-infinite-scroll-component";
import Circular from "@/components/Circular";
import SearchResultGroup from "@/components/SearchResultGroup";
import { SearchResultTabType } from "@/consts/tabType";
import ProductVariationItemList from "@/features/product_variation/components/ProductVariationItemList";
import NotFoundSearchView from "@/components/NotFoundSearchView";
import usePageView from "@/hooks/usePageView";
import ProductVariationItem from "@/features/product_variation/components/ProductVariationItem";
import useProductSearch from "@/features/product_variation/hooks/useProductSearch";
import { ProductKind } from "@/web-client/api";

const SearchInteriorsPage: NextPage = () => {
  usePageView();

  const {
    keyword,
    pagination: { data, dataLength, hasNext, next, notFound, updateItem },
  } = useProductSearch("/search/interiors", ProductKind.INTERIOR);

  return (
    <DefaultLayout className="!bg-white">
      <NextSeo
        title={`検索結果`}
        description={`TECTURE内の家具を検索した結果`}
        noindex={true}
      />

      <SearchResultGroup
        keyword={keyword}
        tabType={SearchResultTabType.Interior}
      >
        <InfiniteScroll
          style={{ overflow: "visible" }}
          dataLength={dataLength}
          next={next}
          hasMore={hasNext}
          loader={<Circular />}
        >
          <ProductVariationItemList
            productVariations={data}
            onRender={(variation) => (
              <ProductVariationItem
                productVariation={variation}
                mutate={(updated) => {
                  updateItem(updated, false);
                }}
              />
            )}
          />
        </InfiniteScroll>
        {notFound && <NotFoundSearchView />}
      </SearchResultGroup>
    </DefaultLayout>
  );
};

export default SearchInteriorsPage;
